var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.$core.breakpoint.width,staticClass:"vk-widget",attrs:{"id":"vk_groups"}})}
var staticRenderFns = []

export { render, staticRenderFns }